/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 *
 **/
import { createIcon } from "@cmp-src/icons/create-icon";
export const UserIcon = createIcon({
  displayName: "UserIcon",
  viewBox: "0 0 16 16",
  path: (
    <g fill="none" stroke="currentColor" strokeWidth={1.5}>
      <path
        d="M1.75 14.25H14.25V11.4108C14.25 10.7285 13.9495 10.1497 13.4515 9.85558C12.2798 9.16349 10.3085 8.26562 8.00005 8.26562C5.69157 8.26562 3.7203 9.16349 2.54857 9.85558C2.05053 10.1498 1.75 10.7285 1.75 11.4108V14.25Z"
        stroke="currentColor"
        strokeWidth={1.5}
      />
      <path
        d="M11.249 4.99902C11.249 6.79341 9.79439 8.24805 8 8.24805C6.20561 8.24805 4.75098 6.79341 4.75098 4.99902C4.75098 3.20464 6.20561 1.75 8 1.75C9.79439 1.75 11.249 3.20464 11.249 4.99902Z"
        stroke="currentColor"
        strokeWidth={1.5}
      />
    </g>
  )
});
